// ------------------------------------
// props 輸入需求 : 
// props.p : object : { data: array }               ( residnet info )
// props.user : object : { data: array }            ( user info )
// ------------------------------------


import React from 'react'
import { useTranslation } from 'react-i18next';
import '../_Resident.scss'

const ResidentUser =(props)=>{
    const {t, i18n} = useTranslation()
    return(
        <div className="flex-grow-1 body-container">
            <div className="body id-grid">
                {props.userData.map((user, index)=><div key={index} className="id">
                    <div className="identify">{(user.role==="doctor")?t("USERS.Dc"):""}</div>
                    <div className="name">
                        {(i18n.language==="en")? <>{user.first_name} {user.last_name}</>
                            :<>{user.last_name}{user.first_name}</>
                        }  
                    </div>
                </div>)}
            </div>
        </div>
    );	

}
export default ResidentUser;